<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2CjSFn/tc-custom/9781504068154.jpg?1702065246342" alt="This image is the cover for the book Sherwood Anderson and Other Famous Creoles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sherwood Anderson and Other Famous Creoles
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A treasury of literary history featuring caricatures of bohemian life in 1920s New Orleans with captions by William Faulkner.</b></p><p>After meeting in the French Quarter, Nobel Prize–winning novelist William Faulkner and renowned silver artist William Spratling shared a house together—and collaborated on a parody volume that offered a witty portrait of the creative denizens of the city, a group that included such future icons as publisher and Broadway producer Horace Liveright, Pulitzer-winning biographer Carl Van Doren,; novelist John Dos Passos, actress and screenwriter Anita Loos, and others. This unique book provides both an enjoyable glimpse into the early lives of prominent literary and artistic figures and a snapshot of New Orleans history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Spratling, William Faulkner
      </h2>
      
      <p class="authorDescription body article">William Spratling was an American silver designer and artist, best known for his influence on twentieth-century Mexican silver design. He accepted a position as an instructor at Tulane University&rsquo;s School of Architecture in New Orleans, Louisiana, in 1921. At the same time, he was an active participant in the Arts and Crafts Club and taught in the New Orleans Art School. Spratling roomed with author William Faulkner during his time in New Orleans, and the two famously collaborated on <I>Sherwood Anderson and Other Famous Creoles</I>, which depicted the bohemian atmosphere of artists and writers like themselves living and working in the French Quarter in the 1920s.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d636d64